import React from "react";
import { Droplet, FileText, Image, Sparkles, Flag, CloudSun } from "lucide-react";

const ITEMS = [
  { icon: Droplet, label: "Ink tanks" },
  { icon: FileText, label: "Bond paper" },
  { icon: Image, label: "Satin photo paper" },
  { icon: Sparkles, label: "Glossy photo paper" },
  { icon: Flag, label: "Indoor Poly Vinyl" },
  { icon: CloudSun, label: "Outdoor Banner Vinyl" },
];

export default function SuppliesList() {
  return (
    <section
      id="supplies-list"
      data-testid="supplies-list-section"
      className="bg-[#F4F6F4] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="mb-14 max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-teal mb-4">
            What you can reorder
          </div>
          <h2
            data-testid="supplies-list-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-navy leading-tight"
          >
            Supplies We Provide
          </h2>
        </div>

        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
          {ITEMS.map((item, i) => {
            const Icon = item.icon;
            return (
              <li
                key={item.label}
                data-testid={`supplies-list-item-${i}`}
                className="group flex items-center gap-4 bg-white border border-slate-200 hover:border-teal/40 rounded-xl px-6 py-5 transition-all hover:shadow-md hover:-translate-y-0.5"
              >
                <span className="flex-shrink-0 w-11 h-11 rounded-lg bg-navy text-white flex items-center justify-center group-hover:bg-teal transition-colors">
                  <Icon className="w-5 h-5" strokeWidth={2} />
                </span>
                <span className="font-serif text-lg font-bold text-navy leading-snug">
                  {item.label}
                </span>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
